import { ETH_TOKEN_ADDRESS } from "@src/config";
import { IToken } from "@src/utils/addTokenToMetamask";

export const skeyTokenData: IToken = {
  address: ETH_TOKEN_ADDRESS,
  symbol: "SKEY",
  decimals: 8,
  image: `${window.location.origin}/images/Skey_Metamask_256x256.png`
};
